import { AlertTriangle, UserCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { emailWarning } from "@/lib/emailCheck";

// Before a sale is saved (and its bill emailed): turn the screen to the member and have them check
// their own details. Typos here mean bills and reminders go nowhere.
export default function ConfirmDetails({ open, details, onConfirm, onEdit, onUseSuggestion }) {
  if (!details) return null;
  const warn = emailWarning(details.email, details.name);
  const rows = [
    ["Name", details.name],
    ["Phone", details.phone],
    ["Email", details.email || "—"],
    ...(details.extra || []),
  ];
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onEdit()}>
      <DialogContent className="bg-[#0f0f0f] border-[#262626] text-zinc-100 max-w-md" data-testid="confirm-details">
        <DialogHeader className="text-left">
          <DialogTitle className="font-display text-xl flex items-center gap-2"><UserCheck className="h-5 w-5 text-emerald-400" /> Check with the member</DialogTitle>
          <DialogDescription className="text-zinc-400">Turn the screen to them. Their bill and reminders go to these details.</DialogDescription>
        </DialogHeader>
        <dl className="space-y-3 mt-1">
          {rows.map(([k, v]) => (
            <div key={k}>
              <dt className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">{k}</dt>
              <dd className={`text-zinc-50 break-all ${k === "Email" || k === "Phone" ? "text-lg font-mono" : "text-lg"}`}>{v || "—"}</dd>
            </div>
          ))}
        </dl>
        {warn && (
          <div className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-3 text-sm text-amber-100 space-y-2" data-testid="confirm-details-warning">
            <div className="flex gap-2"><AlertTriangle className="h-4 w-4 shrink-0 mt-0.5 text-amber-300" />{warn.message}</div>
            {warn.suggestion && onUseSuggestion && (
              <button type="button" onClick={() => onUseSuggestion(warn.suggestion)} className="text-amber-200 underline text-left break-all"
                data-testid="confirm-details-suggestion">Use {warn.suggestion}</button>
            )}
          </div>
        )}
        <div className="flex gap-2 pt-2">
          <button type="button" onClick={onEdit} className="h-11 px-4 rounded-full border border-[#2a2a2a] text-zinc-300" data-testid="confirm-details-edit">Change something</button>
          <button type="button" onClick={onConfirm} className="h-11 flex-1 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-semibold"
            data-testid="confirm-details-ok">All correct, save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
